import React from "react";
import "./style.css"; // Optional if using separate CSS file
import loaderImage from "./../../assets/images/OG-logo-removebg-preview.png"; // or use public path like '/loader.png'
import { CircularProgress } from "@mui/material";
import { ClipLoader } from "react-spinners";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <ClipLoader color="#1976d2" size={80} />
      {/* <CircularProgress color="primary" size={80} /> */}
      {/* <img src={loaderImage} alt="Loading..." className="rotating-loader" /> */}
    </div>
  );
};

export default Loader;
